import React from 'react'
import styles from './style.module.css';

export default function Game({index, title, setModal}) {
    const games = [
        { description: 'Top Grossing' },
        { description: 'Top Rated' },
        { description:'Top Action'},
        { description: 'Online Shooter'},
        { description: 'Open-World'},
        { description: 'Looter Shooter'},
        { description: 'Survival Horror'},
        { description: 'FPS Shooter'},
    ];
    const game = games[index] || { title: 'Unknown', description: 'No Description' };

    

    return (
        <div onMouseEnter={() => {setModal({active: true, index})}} 
        onMouseLeave={() => {setModal({active: false, index})}} className={styles.game}>
            <h2>{title}</h2>
            <p>{game.description}</p>
        </div>
    )
}